/*
 * KindListe3.tsx Entities einer "Kind" als Liste darstellen.
 *
 * Created by Dr. Maximillian Dornseif 2023-10-10 in huWaWi3 33.1.0
 * Copyright (c) 2019, 2020, 2023 HUDORA GmbH
 */

import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar'
import { findAllByKey } from '@hudora/hd-ts-util'
import { DocumentNode } from 'graphql'
import reverse from 'lodash.reverse'
import sortBy from 'lodash.sortby'
import React from 'react'
import { useQuery } from 'urql'

import { IEntity } from '../../../types'
import { useAddPanel3 } from '../../hooks/useAddPanel3'
import { KTTheEntityTable3 } from './KindListeHelpers3'

export interface IKindListe3Props {
  // extends Omit<IEntityTable3Props, 'rowData'> {
  listQuery: DocumentNode // GQL-Abfrage, um an die Daten zu gelangen
  listQueryVars?: Record<string, string>
  mutation?: DocumentNode
  createMutation?: DocumentNode
  createTemplate?: Partial<IEntity>

  title: string // Überschrift
  schemaName: string // Name des Daten-Schemas, dass angezeigt wird
  hideExcept?: string[] // alle Spalten ausser denen mit diesen Namen ausblenden
  commandBarItems?: Array<ICommandBarItemProps>
  rowToolsEnabled?: boolean
  internalDesignatorLink?: boolean
}
/**
 * Zeigt eine Liste mit Entities an und ermöglicht neue Anzulegen.
 * Das ist die default Seite für zB den "Kunden" oder "Gruppen" Bereich.
 * Steht in sehr engem Zusammenhang mit <SchemaTable>,
 * siehe auch dort die Dokumentation.
 */

export const KindListe3 = (props: IKindListe3Props) => {
  const [response] = useQuery({ query: props.listQuery, variables: props.listQueryVars })
  const { data, fetching, error } = response
  const [createItem, createPanel, createButton] = useAddPanel3({
    ...props,
  })

  const items: Array<ICommandBarItemProps> = [createItem]
  let rowData
  if (data?.nodes?.edges) {
    // single level paginated access
    rowData = data?.nodes?.edges.map((x) => x?.node)
  }
  if (!rowData || rowData?.length < 1) {
    // single level non-paginated access
    rowData = data?.entities || data?.entity?.nodes || undefined
  }
  if (!rowData || rowData?.length < 1) {
    // single level non paginated access
    rowData = findAllByKey(data, 'nodes')
  }

  rowData = reverse(sortBy(rowData, ['updated_at', 'designator', 'created_at']))
  console.log('rowData', rowData)

  return (
    <KTTheEntityTable3
      {...props}
      createPanel={createPanel}
      createButton={createButton}
      loading={fetching}
      error={error}
      commandBarItems={items}
      rowData={rowData}
    />
  )
}
